import clsx from 'clsx'
import BaseCard, {
  CardGridProps as BaseCardGridProps,
  CardMetaProps as BaseCardMetaProps,
  CardProps as BaseCardProps,
} from 'antd/lib/card'
import * as styles from './card.module.css'

export interface CardProps extends Omit<BaseCardProps, 'size'> {
  shadow?: boolean | null
}

export const Card = ({
  className,
  shadow,
  ...rest
}: CardProps): JSX.Element => (
  <>
    <BaseCard
      {...rest}
      className={clsx(className, styles.card, { [styles.shadow]: shadow })}
    />
  </>
)

export interface CardMetaProps extends BaseCardMetaProps {}

export const Meta = (props: CardMetaProps): JSX.Element => (
  <>
    <BaseCard.Meta {...props} />
  </>
)

export interface CardGridProps extends BaseCardGridProps {}

export const Grid = (props: CardGridProps): JSX.Element => (
  <>
    <BaseCard.Grid {...props} />
  </>
)
